module.exports = __webpack_public_path__ + "img/logocjzj.3830a170.png";